import React, { createContext, useContext } from "react";
import { useSession, signOut } from "./auth-client";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const { data: session, isPending, error } = useSession();

  // Log any session errors for debugging (but don't block the app)
  if (error) {
    console.warn("Session check error (this is normal if not logged in):", error);
  }

  const logout = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  const value = {
    user: session?.user || null,
    session: session?.session || null,
    isLoading: isPending,
    error: error,
    mfaEnabled: session?.user?.twoFactorEnabled || false,
    logout,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext };
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
